// extracted by mini-css-extract-plugin
export default {"apple":"LinkIcon_apple__rySNI","spotify":"LinkIcon_spotify__InxPA"};